var map = {
	"./_module_demo_/module.json": 83591,
	"./assistant/module.json": 66249,
	"./consumer/module.json": 59328,
	"./dashboard/module.json": 44917,
	"./kitchen-order-ticket/module.json": 58931,
	"./menu-management/module.json": 75373,
	"./profile/module.json": 31553,
	"./settings/module.json": 28766,
	"./shop/module.json": 94134,
	"./sport-hub-club/module.json": 95872,
	"./sport-hub-fantacalcetto/module.json": 48404,
	"./sport-hub-league/module.json": 45445,
	"./sport-hub-pay/module.json": 37237,
	"./sport-hub-pro/module.json": 18793,
	"./sport-hub-web/module.json": 93871,
	"./sport-hub/module.json": 95548,
	"./waitress-order-ticket/module.json": 96685
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9973;
module.exports = webpackAsyncContext;